/**
 * resolveAreaId
 *
 * A pure function that resolves an area ID given a collection name, area name,
 * and the full list of areas and collections.
 *
 * This extracts the logic previously embedded in Redux selectors
 * (`areaIdByNameAndCollectionIdSelector` + `collectionIdByName`) into a
 * standalone, testable, source-agnostic function.
 *
 * @see src/store/selectors/areas.ts — areaIdByNameAndCollectionIdSelector
 * @see src/store/selectors/collections.ts — collectionIdByName
 */
/**
 * Resolves the area ID for the given collection and area names.
 *
 * @param collectionName - The name of the collection to look up.
 * @param areaName - The name of the area within the collection.
 * @param areas - The full list of areas.
 * @param collections - The full list of collections.
 * @returns The area ID, or `undefined` if the collection or area is not found.
 */
export const resolveAreaId = (collectionName, areaName, areas, collections) => {
    if (!collectionName || !areaName) {
        return undefined;
    }
    const collection = collections.find(({ collection: name }) => name === collectionName);
    if (!collection) {
        return undefined;
    }
    const area = areas.find((a) => a.collectionId === collection.id && a.name === areaName);
    return area === null || area === void 0 ? void 0 : area.id;
};
